import { createContext } from 'react';

export const WorkflowActionsContext = createContext(null);
